import type { SmartFolder } from "./types";

// Seed set covering the app's default Smart Folder categories. Users can
// edit or delete any of these, and add their own.
const DEFS: [string, string, string[]][] = [
  ["Shopping", "🛍️", ["amazon.", "flipkart.", "myntra."]],
  ["Finance", "🏦", ["bank", "hdfc", "icici"]],
  ["Food Delivery", "🍔", ["swiggy.", "zomato."]],
  ["Ride Sharing", "🚕", ["uber.", "ola.", "rapido."]],
  ["Entertainment", "🎬", ["netflix.", "spotify.", "primevideo."]],
  ["Travel", "✈️", ["makemytrip.", "airindia.", "booking."]],
  ["Bills", "🧾", ["electricity", "billdesk", "utility"]],
  ["Receipts", "🧾", ["receipt", "invoice", "order-confirmation"]],
  ["Work", "💼", ["slack.", "atlassian.", "zoom."]],
  ["Personal", "👤", []],
  ["Government", "🏛️", ["gov.", "nic.in"]],
  ["Medical", "🏥", ["hospital", "clinic", "pharmacy"]],
  ["Education", "🎓", ["edu.", "university", "coursera."]],
  ["Job Applications", "💼", ["linkedin.", "naukri.", "indeed."]],
  ["Interviews", "📅", ["calendly.", "interview"]],
  ["Documents", "📄", ["docusign.", "adobe."]],
  ["Security", "🔒", ["security-alert", "noreply-security"]],
  ["Newsletters", "📰", ["newsletter", "digest"]],
];

export function buildDefaultSmartFolders(): SmartFolder[] {
  return DEFS.map(([name, icon, values], index) => ({
    id: `default-${index}-${name.toLowerCase().replace(/\s+/g, "-")}`,
    name,
    icon,
    accentIndex: index,
    matchField: "from" as const,
    matchValues: values,
  }));
}
